var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAnimationIn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33301 2.49967C9.33301 2.13148 9.63148 1.83301 9.99967 1.83301H12.6663C13.1968 1.83301 13.7055 2.04372 14.0806 2.41879C14.4556 2.79387 14.6663 3.30257 14.6663 3.83301V13.1663C14.6663 13.6968 14.4556 14.2055 14.0806 14.5806C13.7055 14.9556 13.1968 15.1663 12.6663 15.1663H9.99967C9.63148 15.1663 9.33301 14.8679 9.33301 14.4997C9.33301 14.1315 9.63148 13.833 9.99967 13.833H12.6663C12.8432 13.833 13.0127 13.7628 13.1377 13.6377C13.2628 13.5127 13.333 13.3432 13.333 13.1663V3.83301C13.333 3.6562 13.2628 3.48663 13.1377 3.3616C13.0127 3.23658 12.8432 3.16634 12.6663 3.16634H9.99967C9.63148 3.16634 9.33301 2.86786 9.33301 2.49967ZM6.1949 4.69502C6.45525 4.43467 6.87736 4.43467 7.13771 4.69502L10.4634 8.02072C10.5886 8.14191 10.6663 8.31171 10.6663 8.49967C10.6663 8.59261 10.6473 8.6811 10.613 8.76147C10.5805 8.83765 10.5332 8.90901 10.471 8.97116L7.13771 12.3045C6.87736 12.5648 6.45525 12.5648 6.1949 12.3045C5.93455 12.0441 5.93455 11.622 6.1949 11.3617L8.39024 9.16634H1.99967C1.63148 9.16634 1.33301 8.86786 1.33301 8.49967C1.33301 8.13148 1.63148 7.83301 1.99967 7.83301H8.39008L6.1949 5.63783C5.93455 5.37748 5.93455 4.95537 6.1949 4.69502Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAnimationIn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-animation-in.e2019ef358fd49e895b1cf6f5d383aed.svg";